import { useState } from "react";
import Sidebar from "./sidebar";
import { Outlet } from "react-router-dom";

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <main
        className={`flex-1 p-6 transition-all duration-300
        ${collapsed ? "ml-20" : "ml-64"}`}
      >
        <Outlet context={{ sidebarCollapsed: collapsed }} />
      </main>
    </div>
  );
}
